import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ModalBackdropModule } from './modalBackdrop';
import { ModalBoxModule } from './modalBox';
import { ModalContentModule } from './modalContent';
import { ModalFooterModule } from './modalFooter';
import { ModalHeaderModule } from './modalHeader';
import { ModalItemsActionsModule } from './modalItemActions';
import { ModalSimpleContentModule } from './modalSimpleContent';
import { ModalSubHeaderModule } from './modalSubHeader';
import { ModalTopModule } from './modalTop';

const toExport: any[] = [
    ModalBackdropModule,
    ModalBoxModule,
    ModalContentModule,
    ModalFooterModule,
    ModalHeaderModule,
    ModalItemsActionsModule,
    ModalSimpleContentModule,
    ModalSubHeaderModule,
    ModalTopModule,
];

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        ...toExport,
    ],
    exports: [
        ...toExport,
    ],
    providers: [],
})
export class ModalsComponentsModule { }
